import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class DoubleSlider {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.videoFacades()

    const slides = this.el.querySelectorAll('.double-slider--big-slider .swiper-slide').length
    const loop = slides > 1
    const speed = 800

    // Texte : pas de loop car le nombre de textes peut différer du nombre d'images
    const textEl = this.el.querySelector('.double-slider--text-slider')
    const textCount = textEl ? textEl.querySelectorAll('.swiper-slide').length : 0
    this.text = textEl ? new Swiper(textEl, {
      slidesPerView: 1,
      loop: false,
      speed,
      allowTouchMove: false,
    }) : null

    // Petite image : décalée d'un slide (+1)
    this.small = new Swiper(this.el.querySelector('.double-slider--small-slider'), {
      slidesPerView: 1,
      initialSlide: loop ? 1 : 0,
      loop,
      speed,
      allowTouchMove: false,
    })

    // Grande image : pilote la navigation
    this.big = new Swiper(this.el.querySelector('.double-slider--big-slider'), {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      loop,
      speed,
      allowTouchMove: false,
      autoplay: {
        delay: 9000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: this.el.querySelector('.swiper-button-prev'),
        nextEl: this.el.querySelector('.swiper-button-next'),
      },
    })

    // Texte synchronisé avec modulo : supporte un nombre de textes différent du nombre d'images
    if (this.text && textCount > 0) {
      this.big.on('slideChange', () => {
        this.text.slideTo(this.big.realIndex % textCount, speed, false)
      })
    }

    // Petite image synchronisée avec décalage +1
    this.big.on('slideNextTransitionStart', () => this.small.slideNext())
    this.big.on('slidePrevTransitionStart', () => this.small.slidePrev())
  }

  // Vidéo YouTube : la vignette reste affichée dans le slider, la lecture s'ouvre en popup
  videoFacades() {
    this.el.querySelectorAll('.double-slider--video-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.closest('.double-slider--video')?.dataset.youtubeId
        if (!id) return

        this.big?.autoplay?.stop()
        openVideoModal(id)
      })
    })
  }
}

function getOrCreateVideoModal() {
  let modal = document.querySelector('.double-slider-video-modal')
  if (modal) return modal

  modal = document.createElement('div')
  modal.className = 'double-slider-video-modal'
  modal.innerHTML = `
    <div class="double-slider-video-modal--inner">
      <button type="button" class="double-slider-video-modal--close" aria-label="Fermer la vidéo">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <div class="double-slider-video-modal--frame">
        <iframe src="" title="Lecteur vidéo YouTube" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  `
  document.body.appendChild(modal)

  // Le fond (bg-color sur .double-slider-video-modal lui-même) ferme au clic,
  // mais uniquement si le clic n'a pas été intercepté par .double-slider-video-modal--inner (stopPropagation)
  modal.addEventListener('click', closeVideoModal)
  modal.querySelector('.double-slider-video-modal--inner').addEventListener('click', e => e.stopPropagation())
  modal.querySelector('.double-slider-video-modal--close').addEventListener('click', closeVideoModal)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeVideoModal()
  })

  return modal
}

function openVideoModal(youtubeId) {
  const modal = getOrCreateVideoModal()
  modal.querySelector('iframe').src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`
  modal.classList.add('is-open')
  document.body.classList.add('double-slider-video-modal-open')
}

function closeVideoModal() {
  const modal = document.querySelector('.double-slider-video-modal')
  if (!modal) return

  modal.classList.remove('is-open')
  document.body.classList.remove('double-slider-video-modal-open')
  modal.querySelector('iframe').src = ''
}
